import { proxy } from "valtio";

export const cateringStore = proxy({
  orderBundlesToken: "",
});
